import ApiService from '../../services/api.service';

export const postRegistrar = async ({ commit }, payload) => {
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/usuarioUNI/registrar');
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.post(url, payload);
    return response.data;
  } catch (err) {
    console.log('this', err);
    console.log(err.response);
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    if (err.response.data.codigo === '91') return err.response.data.codigo;
    else return false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const postResetAccount = async ({ commit }, payload) => {
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/usuarioUNI/resetAccount');
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.post(url, payload);
    return response.data;
  } catch (err) {
    console.log(err.response);
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const postRecuperarPassword = async ({ commit }, payload) => {
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/usuarioUNI/resetPassword');
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.post(url, payload);
    return response.data;
  } catch (err) {
    console.log(err.response);
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};
